const styles = {
  loadingSpinner: {
    marginTop: 20,
  },
};

export { styles };
